import { type State } from 'app/common/ui-components/filter'

import { flags as groupComplexesSpecial } from '../groupComplexesSpecial'
import { flags as group } from '../group'
import { flags as period } from '../period'

const splitByDaysActivity = (state: State) => {
  return (
    (group.byProductTypeSelected(state) && period.moreThanOneDaySelected(state)) ||
    (groupComplexesSpecial.byPaymentMethodSelected(state) && period.moreThanOneDaySelected(state))
  )
}

export default splitByDaysActivity
